import { createSelector } from 'reselect';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { getActiveFolder, getViewOptions } from './options';
import { getState } from './state';
import { getBucketStreamId } from '../../utils';
import { getActiveDrawerStreamId, getLatestTs } from './drawer';
import { GROUP_FEED_BUCKET, USER_FEED_BUCKET } from '../../constants';
export const getDrawerStreamEntry = createSelector([
    (state)=>state,
    getActiveDrawerStreamId,
    (state, bucketId)=>bucketId
], (globalState, drawerStreamId, bucketId)=>{
    if (bucketId && drawerStreamId) {
        const items = streamSelectors.getItems(globalState, drawerStreamId);
        return items.find((item)=>{
            var _item_bucket;
            return ((_item_bucket = item.bucket) === null || _item_bucket === void 0 ? void 0 : _item_bucket.bucket) === bucketId;
        });
    }
    return undefined;
});
export const getBucket = createSelector([
    (state)=>state,
    (state, bucketId)=>bucketId
], (globalState, bucketId)=>{
    var _getDrawerStreamEntry;
    return (_getDrawerStreamEntry = getDrawerStreamEntry(globalState, bucketId)) === null || _getDrawerStreamEntry === void 0 ? void 0 : _getDrawerStreamEntry.bucket;
});
export const getBucketData = createSelector([
    getState,
    (state, bucketId)=>bucketId
], (state, bucketId)=>state.bucketData[bucketId]);
const getActiveBucketId = createSelector([
    getViewOptions
], (viewOptions)=>{
    var _viewOptions_activeBucket;
    return (_viewOptions_activeBucket = viewOptions.activeBucket) === null || _viewOptions_activeBucket === void 0 ? void 0 : _viewOptions_activeBucket.bucket;
});
export const getActiveBucket = createSelector([
    (state)=>state,
    getActiveBucketId,
    getLatestTs
], (state, activeBucketId, latestTs)=>{
    if (activeBucketId && [
        USER_FEED_BUCKET,
        GROUP_FEED_BUCKET
    ].includes(activeBucketId)) {
        return {
            bucket: activeBucketId,
            ts: latestTs
        };
    }
    return getBucket(state, activeBucketId);
});
export const getActiveBucketHeader = createSelector([
    (state)=>state,
    getActiveBucket
], (state, activeBucket)=>{
    var _getBucketData;
    if (!activeBucket) {
        return undefined;
    }
    return (_getBucketData = getBucketData(state, activeBucket.bucket)) === null || _getBucketData === void 0 ? void 0 : _getBucketData.header;
});
export const getActiveBucketFilters = createSelector([
    (state)=>state,
    getActiveBucket
], (state, activeBucket)=>{
    var _getBucketData;
    if (!activeBucket) {
        return [];
    }
    var _getBucketData_filters;
    return (_getBucketData_filters = (_getBucketData = getBucketData(state, activeBucket.bucket)) === null || _getBucketData === void 0 ? void 0 : _getBucketData.filters) !== null && _getBucketData_filters !== void 0 ? _getBucketData_filters : [];
});
export const getActiveBucketHasFilters = createSelector([
    getActiveBucketFilters
], (filters)=>filters.length > 0);
export const getActiveBucketStreamParams = createSelector([
    getViewOptions,
    getActiveFolder
], (viewOptions, activeFolder)=>{
    const activeBucket = viewOptions.activeBucket;
    if (!activeBucket) {
        return {
            bucket: ''
        };
    }
    return {
        folder: activeFolder,
        bucket: activeBucket.bucket,
        filterId: activeBucket.filterId
    };
});
export const getActiveBucketStreamId = createSelector([
    getActiveBucketStreamParams
], (params)=>{
    if (params.bucket.length === 0) {
        return undefined;
    }
    return getBucketStreamId(params);
});
export const getActiveBucketFilterId = createSelector([
    getViewOptions
], (viewOptions)=>{
    var _viewOptions_activeBucket;
    return (_viewOptions_activeBucket = viewOptions.activeBucket) === null || _viewOptions_activeBucket === void 0 ? void 0 : _viewOptions_activeBucket.filterId;
});
export const isAllFeedBucket = createSelector([
    getActiveBucketId
], (activeBucketId)=>activeBucketId === USER_FEED_BUCKET || activeBucketId === GROUP_FEED_BUCKET);

//# sourceMappingURL=bucket.js.map